<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                        <li class="pr-3"><a class="cursor-pointer">Configuration</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Email Templates</a></li>
                    </ul>

                    <h3>Manage Email Templates</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callLoadDefaultUnpaidTemplates" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Load Defaults</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 0.5rem;"></div>

                    <div class="field">
                        <p><b>Parameters Available</b> - [firstname], [lastname], [full-name], [guardian-1-full-name],
                            [guardian-2-full-name], [amount-outstanding], [company-name], [banking-details], [email],
                            [support-phone], [support-email], [paymentLink].</p>
                    </div>

                    <div style="height: 1rem;"></div>

                    <h3>Email Templates</h3>

                    <div class="field">
                        <label for="gentleNoticeEmailTemplate">Gentle Notice Email Template</label>
                        <Editor v-model="companyConfiguration.gentleNoticeEmailTemplate" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <div class="field">
                        <label for="firstNoticeEmailTemplate">First Notice Email Template</label>
                        <Editor v-model="companyConfiguration.firstNoticeEmailTemplate" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <div class="field">
                        <label for="finalNoticeEmailTemplate">Final Notice Email Template</label>
                        <Editor v-model="companyConfiguration.finalNoticeEmailTemplate" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <div class="field">
                        <label for="litigationNoticeEmailTemplate">Litigation Notice Email Template</label>
                        <Editor v-model="companyConfiguration.litigationNoticeEmailTemplate"
                                editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <div class="field">
                        <label for="memberLiableNoticeEmailTemplate">Member Liable Notice Email Template</label>
                        <Editor v-model="companyConfiguration.memberLiableNoticeEmailTemplate"
                                editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <div class="field">
                        <label for="unpaidInvoiceEmailTemplate">Unpaid Invoice Email Template</label>
                        <Editor v-model="companyConfiguration.unpaidInvoiceEmailTemplate" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <div class="field">
                        <label for="unpaidInvoiceHealthinsuranceEmailTemplate">Unpaid Invoice (Health Insurance Related)
                            Email
                            Template</label>
                        <Editor v-model="companyConfiguration.unpaidInvoiceHealthinsuranceEmailTemplate"
                                editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <div class="field">
                        <label for="paidInvoiceEmailTemplate">Paid Invoice Email Template</label>
                        <Editor v-model="companyConfiguration.paidInvoiceEmailTemplate" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <div class="field">
                        <label for="statementEmailTemplate">Statement Email Template</label>
                        <Editor v-model="companyConfiguration.statementEmailTemplate" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <div style="height: 2rem;"></div>

                    <h3>SMS Templates</h3>

                    <div class="field">
                        <label for="gentleNoticeMessageTemplate">Gentle Notice Message Template</label>
                        <Textarea v-model.trim="companyConfiguration.gentleNoticeMessageTemplate" :autoResize="true"
                                  rows="3" cols="50"/>
                    </div>

                    <div class="field">
                        <label for="firstNoticeMessageTemplate">First Notice Message Template</label>
                        <Textarea v-model.trim="companyConfiguration.firstNoticeMessageTemplate" :autoResize="true"
                                  rows="3" cols="50"/>
                    </div>

                    <div class="field">
                        <label for="finalNoticeMessageTemplate">Final Notice Message Template</label>
                        <Textarea v-model.trim="companyConfiguration.finalNoticeMessageTemplate" :autoResize="true"
                                  rows="3" cols="50"/>
                    </div>

                    <div class="field">
                        <label for="litigationNoticeMessageTemplate">Litigation Notice Message Template</label>
                        <Textarea v-model.trim="companyConfiguration.litigationNoticeMessageTemplate" :autoResize="true"
                                  rows="3" cols="50"/>
                    </div>

                    <div class="field">
                        <label for="memberLiableNoticeMessageTemplate">Member Liable Notice Message Template</label>
                        <Textarea v-model.trim="companyConfiguration.memberLiableNoticeMessageTemplate"
                                  :autoResize="true" rows="3" cols="50"/>
                    </div>

                    <div class="field">
                        <label for="unpaidInvoiceMessageTemplate">Unpaid Invoice Message Template</label>
                        <Textarea v-model.trim="companyConfiguration.unpaidInvoiceMessageTemplate" :autoResize="true"
                                  rows="3" cols="50"/>
                    </div>

                    <div class="field">
                        <label for="unpaidInvoiceHealthinsuranceMessageTemplate">Unpaid Invoice (Health Insurance
                            Related) Message
                            Template</label>
                        <Textarea v-model.trim="companyConfiguration.unpaidInvoiceHealthinsuranceMessageTemplate"
                                  :autoResize="true" rows="3" cols="50"/>
                    </div>

                    <div class="field">
                        <label for="paidInvoiceMessageTemplate">Paid Invoice Message Template</label>
                        <Textarea v-model.trim="companyConfiguration.paidInvoiceMessageTemplate" :autoResize="true"
                                  rows="3" cols="50"/>
                    </div>

                    <div class="field">
                        <label for="statementMessageTemplate">Statement Message Template</label>
                        <Textarea v-model.trim="companyConfiguration.statementMessageTemplate" :autoResize="true"
                                  rows="3" cols="50"/>
                    </div>

                    <Button label="Save" class="mr-2 mb-2" @click="updateConfiguration"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Load Defaults</h3>

                    <div class="field">
                        <label for="confirmationResponse">Do You Wish to Load the Default Values?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>

                    <Button label="Save" class="mr-2 mb-2" @click="loadDefaultUnpaidTemplates"></Button>

                </div>
            </div>
        </div>


    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import CompanyService from "@/service/CompanyService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        await this.loadCompanyContext();

    },
    data() {

        return {
            profile: {},
            activeTab: 1,
            companyConfiguration: {},
            confirmationResponse: 'N',
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ]
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                // Attempt to get user data
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;

            try {
                const [userConfigData] = await Promise.all([
                    UserService.getUserConfig(this.userStore.user.id)
                ]);

                this.userConfiguration = userConfigData.data;
                console.log("[ConfigurationTemplates][mounted] userConfigData.data = ", userConfigData.data);
            } catch (e) {
                console.error("[ConfigurationTemplates][mounted] Could not find user config for user = ", this.userStore.user.id);
            }

            try {
                const [companyData, companyConfigData] = await Promise.all([
                    CompanyService.getCompany(this.profile.companyId),
                    CompanyService.getCompanyConfiguration(this.profile.companyId)
                ]);

                this.company = companyData.data;
                this.companyConfiguration = companyConfigData.data;
                console.log("[ConfigurationTemplates][mounted] companyData.data = ", companyData.data);
                console.log("[ConfigurationTemplates][mounted] companyConfigData.data = ", companyConfigData.data);

            } catch (e) {
                console.error("[ConfigurationTemplates][mounted] Error fetching additional data = ", e);
            }

            console.log("[ConfigurationTemplates][mounted] this.userConfiguration = ", this.userConfiguration);
            console.log("[ConfigurationTemplates][mounted] this.company = ", this.company);
            console.log("[ConfigurationTemplates][mounted] this.companyConfiguration = ", this.companyConfiguration);
        },
        callHelp() {
            console.log('[ConfigurationTemplates][callHelp] Start.');
        },
        callSupport() {
            console.log('[ConfigurationTemplates][callSupport] Start.');
        },
        cleanUpHTML(html) {
            return html ?? '';
        },
        callLoadDefaultUnpaidTemplates() {
            this.confirmationResponse = 'N';
            this.activeTab = 2;
        },
        async updateConfiguration() {

            try {

                console.log('[ConfigurationTemplates][updateConfiguration] this.companyConfiguration.gentleNoticeEmailTemplate = ', this.companyConfiguration.gentleNoticeEmailTemplate);

                var updatedConfiguration = {
                    gentleNoticeEmailTemplate: this.cleanUpHTML(this.companyConfiguration.gentleNoticeEmailTemplate),
                    firstNoticeEmailTemplate: this.cleanUpHTML(this.companyConfiguration.firstNoticeEmailTemplate),
                    finalNoticeEmailTemplate: this.cleanUpHTML(this.companyConfiguration.finalNoticeEmailTemplate),
                    litigationNoticeEmailTemplate: this.cleanUpHTML(this.companyConfiguration.litigationNoticeEmailTemplate),
                    memberLiableNoticeEmailTemplate: this.cleanUpHTML(this.companyConfiguration.memberLiableNoticeEmailTemplate),
                    unpaidInvoiceEmailTemplate: this.cleanUpHTML(this.companyConfiguration.unpaidInvoiceEmailTemplate),
                    unpaidInvoiceHealthinsuranceEmailTemplate: this.cleanUpHTML(this.companyConfiguration.unpaidInvoiceHealthinsuranceEmailTemplate),
                    paidInvoiceEmailTemplate: this.cleanUpHTML(this.companyConfiguration.paidInvoiceEmailTemplate),
                    statementEmailTemplate: this.cleanUpHTML(this.companyConfiguration.statementEmailTemplate),
                    gentleNoticeMessageTemplate: this.companyConfiguration.gentleNoticeMessageTemplate,
                    firstNoticeMessageTemplate: this.companyConfiguration.firstNoticeMessageTemplate,
                    finalNoticeMessageTemplate: this.companyConfiguration.finalNoticeMessageTemplate,
                    litigationNoticeMessageTemplate: this.companyConfiguration.litigationNoticeMessageTemplate,
                    memberLiableNoticeMessageTemplate: this.companyConfiguration.memberLiableNoticeMessageTemplate,
                    unpaidInvoiceMessageTemplate: this.companyConfiguration.unpaidInvoiceMessageTemplate,
                    unpaidInvoiceHealthinsuranceMessageTemplate: this.companyConfiguration.unpaidInvoiceHealthinsuranceMessageTemplate,
                    paidInvoiceMessageTemplate: this.companyConfiguration.paidInvoiceMessageTemplate,
                    statementMessageTemplate: this.companyConfiguration.statementMessageTemplate
                };

                console.log("[ConfigurationTemplates][processUpdateConfiguration] Updated configuration. Data = ", updatedConfiguration);

                // Delete the appointment
                const response = await CompanyService.updateCompanyConfiguration(this.profile.companyId, updatedConfiguration);
                console.log('[ConfigurationTemplates][updateConfiguration] Response = ', response);

                const [companyConfigData] = await Promise.all([
                    CompanyService.getCompanyConfiguration(this.profile.companyId)
                ]);

                this.companyConfiguration = companyConfigData.data;
                console.log("[ConfigurationTemplates][updateConfiguration] this.companyConfiguration = ", this.companyConfiguration);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Configuration updated',
                    life: 3000
                });

            } catch (error) {
                console.error('[ConfigurationTemplates][updateConfiguration] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update configuration. Please try again.',
                    life: 3000
                });
            }

        },
        async loadDefaultUnpaidTemplates() {

            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {

                try {
                    // Delete the appointment
                    const response = await CompanyService.loadDefaultUnpaidTemplates(this.profile.companyId);
                    console.log('[ConfigurationTemplates][deletePhoneCall] Response = ', response);

                    const [companyConfigData] = await Promise.all([
                        CompanyService.getCompanyConfiguration(this.profile.companyId)
                    ]);

                    this.companyConfiguration = companyConfigData.data;
                    console.log("[ConfigurationTemplates][mounted] companyConfigData.data = ", companyConfigData.data);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Default Templates Loaded',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[ConfigurationTemplates][deletePhoneCall] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to load default templates. Please try again.',
                        life: 3000
                    });
                }

            }

            this.activeTab = 1;
            this.submitted = false;

        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
